<template>
	<div>
		<slot
			:headers="[...selectedHeaders, actions]"
			:openCustomizer="openCustomizer">
		</slot>

		<v-dialog
			v-model="showDialog"
			max-width="700px"
			transition="dialog-transition">
			<v-card class="pa-3">
				<div class="drag-container">
					<div
						style="flex: 1"
						class="text-center mb-3 text-body-1 font-weigh-bold">
						الحقول المختارة
					</div>
					<div
						style="flex: 1"
						class="text-center mb-3 text-body-1 font-weigh-bold">
						الحقول المتاحة
					</div>
				</div>
				<div class="drag-container">
					<div
						id="area-1"
						class="drag-area">
						<draggable
							:list="selectedHeaders"
							group="people"
							@change="updateCash">
							<v-card
								class="drag-item elevation-3"
								v-for="element in selectedHeaders"
								:key="element.value">
								{{ element.text || element.name }}
							</v-card>
						</draggable>
					</div>
					<div
						id="area-2"
						class="drag-area">
						<draggable
							:list="unselectedHeaders"
							group="people">
							<v-card
								class="drag-item elevation-3"
								v-for="element in unselectedHeaders"
								:key="element.value">
								{{ element.text || element.name }}
							</v-card>
						</draggable>
					</div>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import { getObjectFromJSON, setObjectToJSON } from '@/utils/helpers';
import { STORAGE } from '@/utils/constants';

export default {
	props: {
		localStorageName: { default: null },
		headers: { default: [] },
	},

	components: {
		draggable,
	},

	data() {
		return {
			cash: '',

			drag: false,

			actions: { text: '', value: 'actions', name: 'actions', width: 40 },

			selectedHeaders: [],
			unselectedHeaders: [],
			newHeaders: [],

			showDialog: false,
		};
	},

	methods: {
		init() {
			this.selectedHeaders = [];
			this.unselectedHeaders = [];
			this.newHeaders = [];
			this.cash = '';
			if (localStorage.getItem(STORAGE.CASH) && this.localStorageName) {
				this.cash =
					getObjectFromJSON(localStorage.getItem(STORAGE.CASH), this.localStorageName) || '';
			}

			this.sortTheHeaders();
			this.updateCash();
		},

		openCustomizer() {
			this.showDialog = true;
		},

		sortTheHeaders() {
			const sorter = this.cash.length
				? this.cash.split('.').map((e) => (isNaN(Number(e)) ? e : Number(e)))
				: [];

			for (let i = 0; i < sorter.length; i++) {
				const key = sorter[i];
				if (key === -1) {
					this.unselectedHeaders.push(this.headers[i]);
				}
				if (typeof key === 'number' && key >= 0) {
					this.selectedHeaders[key] = this.headers[i];
				}
			}

			this.newHeaders = this.headers.slice(sorter.length, this.headers.length);
			this.selectedHeaders.push(...this.newHeaders);
		},

		updateCash() {
			const temp = [];
			for (let i = 0; i < this.headers.length; i++) {
				const head = this.headers[i];

				temp.push(this.selectedHeaders.findIndex((e) => e.value === head.value));
			}
			this.cash = temp.join('.');
		},
	},

	watch: {
		cash() {
			if (this.localStorageName)
				localStorage.setItem(
					STORAGE.CASH,
					setObjectToJSON(localStorage.getItem(STORAGE.CASH), this.localStorageName, this.cash),
				);
		},
		localStorageName() {
			this.init();
		},
	},

	mounted() {
		this.init();
	},
};
</script>

<style lang="scss" scoped>
.drag-container {
	display: flex;
	width: 100%;
}
.drag-area {
	height: 400px;
	flex: 1;
	border: 1px solid #aaa;
	border-radius: 5px;
	margin: 0 5px;
	padding: 10px;
	overflow-y: auto;
	> div {
		height: 100%;
	}
}
.drag-item {
	width: 100%;
	padding: 10px;
	margin-bottom: 5px;
}

.gu-mirror {
	position: fixed !important;
	margin: 0 !important;
	z-index: 9999 !important;
	opacity: 0.8;
	background-color: white;
	direction: rtl;
}
.gu-hide {
	display: none !important;
}
.gu-unselectable {
	-webkit-user-select: none !important;
	-moz-user-select: none !important;
	-ms-user-select: none !important;
	user-select: none !important;
}
.gu-transit {
	opacity: 0.2;
}
</style>
